import yup from 'utils/yup';

export const initialPaylocityIntegrationFormData = {
  paylocity_company_id: '',
  first_name: '',
  last_name: '',
  email: '',
  company_name: '',
  phone: '',
};

export const paylocityIntegrationFormValidationSchema = yup.object().shape({
  first_name: yup.string().required(),
  last_name: yup.string().required(),
  email: yup.string().email().required(),
  company_name: yup.string().required(),
  phone: yup.string().required(),
});
